import Holding from "./Holding";
import Prices from "./Prices";
import { Transaction } from "./Transaction";

export default class Summarize {
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // graph
    static graph(holdings:Holding[], end:Date) {
        return this.data(holdings, end, false).map(row => [row[0], row.at(-1)])
    }
    static data(holdings:Holding[], end:Date, addHeader:boolean){
        const {transactions,holdingIds,qty,startYear,endYear,endYYMM,startYYMM} = this._init(holdings, end)
        const tickers = Object.keys(holdingIds).sort()
        const assets : Array<any>[] = []
        if (addHeader) assets.push(["date",...tickers,"total"])
        for(let year=startYear; year<=endYear; year++) {
            let month = year==startYear ? startYYMM%100 : 0
            for(month; month<12; month++) {
                const yymm = year*100+month
                if (yymm>endYYMM) break;
                else if (yymm>202200) assets.push([`${year}-${(month+1).toString().padStart(2,"0")}`, ...this._values(tickers, holdingIds, yymm, transactions, qty)])
            }
        }
        return assets
    }
    private static _values(tickers:string[], holdingIds:Record<string, Holding>, yymm:number, trans:Record<string,Transaction[]>, qty:Record<string,number>) {
        var total = 0;
        const ret : number[] = []
        const today = new Date()
        const todayYYMM = today.getFullYear()*100 + (today.getMonth())
        for(const id of tickers){
            const ts = trans[id]
            const holding = holdingIds[id]
            const exchange = holding.exchange
            while(ts.length){
                const t = ts[0]
                const ym = t.date.getFullYear()*100+t.date.getMonth()
                if (ym>yymm) break;
                if (t.isBuyOrSell || t.isInterest || t.isAdjust) qty[id] += t.quantity;
                ts.shift()
            }
            const price = Prices.i.getHistoricPrice(id, yymm==todayYYMM ? today : new Date(~~(yymm/100)))
            const sum = price*(qty[id]||0)*exchange
            ret.push(sum)
            total += sum
        }
        ret.push(total)
        return ret
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // init
    private static _init(holdings:Holding[], end:Date=new Date()){
        const transactions : Record<string,Transaction[]> = {}
        const holdingIds : Record<string, Holding> = {}
        const qty : Record<string,number> = {}
        const endYear = end.getFullYear()
        const endYYMM = endYear*100 + end.getMonth()
        
        let startYear = endYear;
        let startYYMM = endYYMM
        for(const holding of holdings) {
            if (holding.transactions.length==0) continue

            holdingIds[holding.id] = holding
            qty[holding.id] = 0;

            const trans = transactions[holding.id] = holding.transactions.slice(0).sort((l,r) => l.date<r.date ? -1 : 1)
            const year = trans[0].date.getFullYear()
            const yymm = year*100 + trans[0].date.getMonth()
            if (yymm<startYYMM) {
                startYYMM = yymm;
                startYear = year
            }
        }
        return {startYYMM, startYear, endYear, endYYMM, transactions, holdingIds, qty}
    }
}
